
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'

var BuyOfficeApplyPage = Vue.extend({})
Vue.component('buyOfficeApply-page', BuyOfficeApplyPage)

export default {
  name: 'BuyOfficeApplyPage',
  components: {
    XTable
  },
  props: {

  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      flowId: ''
    }
  },
  mounted () {
    // this.$emit('sendTitleToParent','借款申请');
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/launch/attendance/buyOfficeApply.vue